export const multilingualManifests = {
  'ar' : {
    'label': 'العربية',
    'manifests': [
    'https://www.agda.ae/العربية/catalogue/tna/fo/371/168903/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fo/93/137/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fo/371/126991/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fo/1016/83/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fco/8/2485/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fco/8/68/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fco/8/1268/iiif/manifest',
    'https://www.agda.ae/العربية/catalogue/tna/fo/371/120583/iiif/manifest'
  ]},
  'en' : {
    'label': 'English',
    'manifests': [
    'https://www.agda.ae/en/catalogue/tna/fo/93/137/iiif/manifest',
    'https://www.agda.ae/en/catalogue/tna/fco/8/3812/iiif/manifest', 
    'https://www.agda.ae/en/catalogue/tna/fco/8/538/iiif/manifest', 
    'https://www.agda.ae/en/catalogue/tna/fo/1016/835/iiif/manifest', 
    'https://www.agda.ae/en/catalogue/tna/fo/371/132832/iiif/manifest', 
    'https://iiif.wellcomecollection.org/presentation/v2/b28047771/',
    'https://iiif.wellcomecollection.org/presentation/v2/b30748471/',
    'https://iiif.wellcomecollection.org/presentation/v2/b20403604/',
    'https://iiif.wellcomecollection.org/presentation/v2/b30752176/',
    'https://iiif.wellcomecollection.org/presentation/v2/b22015140/',
    'https://iiif.wellcomecollection.org/presentation/v2/b22431160/'
  ]},
  'fr' : {
    'label': 'Francais',
    'manifests': [
    'https://collections.maison-salins.fr/iiif/2/108217/manifest',
    'https://collections.maison-salins.fr/iiif/2/1753/manifest',
    'https://collections.maison-salins.fr/iiif/2/287/manifest',
    'https://collections.maison-salins.fr/iiif/2/2566/manifest',
    'https://collections.maison-salins.fr/iiif/2/3354/manifest',
    'https://collections.maison-salins.fr/iiif/2/3359/manifest',
    'https://collections.maison-salins.fr/iiif/2/50326/manifest',
    'https://collections.maison-salins.fr/iiif/2/50323/manifest',
    'https://collections.maison-salins.fr/iiif/2/1648/manifest'
  ]}
} 